'use client';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
import styles from './MerchantsImpact.module.css';

export default function MerchantsImpact() {
  const { t } = useTypedTranslation();

  return (
    <section className={styles.impactSection}>
      <div className={styles.container}>
        <h2 className={styles.heading}>{t('merchants.impact.heading')}</h2>

        <div className={styles.statsContainer}>
          <div className={styles.statItem}>
            <span className={styles.statPercentage}>x3</span>
            <p className={styles.statDescription}>{t('merchants.impact.stats.customerSpending')}</p>
          </div>

          <div className={styles.statItem}>
            <span className={styles.statPercentage}>+20/25%</span>
            <p className={styles.statDescription}>{t('merchants.impact.stats.increasedSales')}</p>
          </div>

          <div className={styles.statItem}>
            <span className={styles.statPercentage}>+85%</span>
            <p className={styles.statDescription}>{t('merchants.impact.stats.recoveredSales')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
